import { render, staticRenderFns } from "./tagsComp.vue?vue&type=template&id=5ef119f6&scoped=true&"
import script from "./tagsComp.vue?vue&type=script&lang=js&"
export * from "./tagsComp.vue?vue&type=script&lang=js&"
import style0 from "./tagsComp.vue?vue&type=style&index=0&id=5ef119f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef119f6",
  null
  
)

export default component.exports